import { render, staticRenderFns } from "./SelectGroup.vue?vue&type=template&id=3ba3b4dc&scoped=true&"
import script from "./SelectGroup.vue?vue&type=script&lang=js&"
export * from "./SelectGroup.vue?vue&type=script&lang=js&"
import style0 from "./SelectGroup.vue?vue&type=style&index=0&id=3ba3b4dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba3b4dc",
  null
  
)

export default component.exports